export default {"src":"/_next/static/media/events.e3cc035b.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};